import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import ItemCard from "@/components/ItemCard";
import { SquaresFour, AppWindow, Clock, Image as ImageIcon } from "@phosphor-icons/react";

const filters = [
  { key: "all", label: "All", icon: SquaresFour },
  { key: "icon_pack", label: "Icon Packs", icon: AppWindow },
  { key: "widget", label: "Widgets", icon: Clock },
  { key: "wallpaper", label: "Wallpapers", icon: ImageIcon },
];

export default function Marketplace() {
  const [active, setActive] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = active === "all" ? {} : { type: active };
    api.get("/items", { params }).then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, [active]);

  return (
    <div className="grid-bg min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00E5FF]">The Marketplace</span>
        <h1 className="font-display font-black text-4xl lg:text-6xl tracking-tighter uppercase mt-3">
          Dress up your device
        </h1>
        <p className="text-white/60 text-lg mt-5 max-w-2xl">
          Browse the full catalog. Premium members download everything, unlimited.
        </p>

        <div className="flex flex-wrap gap-3 mt-10 mb-12">
          {filters.map((f) => {
            const Icon = f.icon;
            const on = active === f.key;
            return (
              <button
                key={f.key}
                data-testid={`filter-${f.key}`}
                onClick={() => setActive(f.key)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-sm text-sm font-bold transition-all ${
                  on
                    ? "bg-[#00E5FF] text-[#05050A] shadow-[0_0_20px_rgba(0,229,255,0.4)]"
                    : "glass border border-white/15 text-white/70 hover:border-[#00E5FF]/50 hover:text-white"
                }`}
              >
                <Icon weight={on ? "fill" : "regular"} size={18} />
                {f.label}
              </button>
            );
          })}
        </div>

        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={`item-skeleton-${i}`} className="aspect-[4/5] rounded-lg glass animate-pulse" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <p className="text-white/40 py-20 text-center">No items yet. Check back soon.</p>
        ) : (
          <motion.div layout className="grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="marketplace-grid">
            {items.map((it) => (
              <ItemCard key={it.id} item={it} />
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
}
